// Core
import React from "react"
import styled from "styled-components"

// Assets
// import WorshipBigImg from "../../../../assets/miscellaneous/worship-big-bw.png"
import HeroImg from "../../../../assets/miscellaneous/hero.jpg"
import ODGWhiteLogo from "../../../../assets/logo/odg-white-logo.svg"

// Components
import BaseContainer from "../../../../components/BaseContainer"
// import CTALink from "../../../../components/CTALink"

// Styles
import size from "../../../../styles/size"

// Styles
const Section = styled.section`
  height: 100rem;
  padding-top: 10rem;
  padding-bottom: 10rem;

  background: url(${HeroImg}) #000000;
  background-repeat: no-repeat;
  background-size: cover;

  text-align: center;

  img {
    width: 100%;
    max-width: 65rem;
    margin-top: 17rem;
  }

  @media (max-width: ${size.laptop}) {
    height: 70rem;

    img {
      margin-top: 8rem;
    }
  }
`

const CopyContainer = styled.section`
  margin: 6rem auto 0 auto;

  font-weight: 400;
  font-size: 2.8rem;
  color: #ffffff;

  width: 100%;
  max-width: 54rem;

  strong {
    font-weight: 600;
    text-decoration: underline;
  }

  a {
    margin-top: 7rem;
  }
`

export default function Hero() {
  return (
    <Section>
      <BaseContainer displayBlock>
        <img src={ODGWhiteLogo} alt="Oceano da Graça" />

        <CopyContainer>
          Somos uma igreja que ama servindo e serve amando pessoas
        </CopyContainer>
      </BaseContainer>
    </Section>
  )
}
